import React, { PureComponent } from 'react';
import style from './style.scss';

interface INotesFieldProps {
  type: string;
  text: string;
  className?: string;
}

interface INotesFieldState {
  isScrollable: boolean;
}

class NotesField extends PureComponent<INotesFieldProps, INotesFieldState> {
  private contentRef = React.createRef<HTMLDivElement>();
  private observer: ResizeObserver | null = null;

  constructor(props: INotesFieldProps) {
    super(props);
    this.state = {
      isScrollable: false,
    };
  }

  checkScrollable = (): void => {
    const element = this.contentRef.current;
    if (element) {
      const isContentScrollable = element.scrollHeight > element.clientHeight;
      this.setState({ isScrollable: isContentScrollable });
    }
  };

  componentDidMount(): void {
    this.checkScrollable();
    // Check again after content might have changed
    if (typeof ResizeObserver !== 'undefined') {
      this.observer = new ResizeObserver(this.checkScrollable);
      if (this.contentRef.current && this.observer) {
        this.observer.observe(this.contentRef.current);
      }
    }
  }

  componentDidUpdate(prevProps: INotesFieldProps): void {
    if (prevProps.text !== this.props.text) {
      this.checkScrollable();
    }
  }

  componentWillUnmount(): void {
    if (this.observer) {
      this.observer.disconnect();
    }
  }

  render(): React.ReactNode {
    const { text, className } = this.props;
    const { isScrollable } = this.state;

    return (
      <div
        ref={this.contentRef}
        className={`${style.notes} ${isScrollable ? style['is-scrollable'] : ''} ${className}`}
      >
        {text}
      </div>
    );
  }
}

export default NotesField;
